import { Button, Center, Container, Paper, Stack, Text, Title } from '@mantine/core';
import { IconHome } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function MeetingNotFound({
    roomName,
    reason = 'notFound',
}: Readonly<{ roomName: string; reason?: 'notFound' | 'guestsClosed' | 'removed' }>) {
    const { t } = useTranslation('prejoin');

    return (
        <Center mih="100dvh" p="md">
            <Container p={0} size="xs" w="100%">
                <Paper withBorder p="xl">
                    <Stack align="flex-start" gap="md">
                        <Title order={2}>{t(`${reason}.title`)}</Title>
                        <Text c="dimmed">{roomName}</Text>
                        <Text>{t(`${reason}.description`)}</Text>
                        <Button component={Link} leftSection={<IconHome size={20} />} to="/" variant="light">
                            {t('notFound.home')}
                        </Button>
                    </Stack>
                </Paper>
            </Container>
        </Center>
    );
}
